import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    cajaRegistroOrigenId: 0,
    cajaRegistroOrigen: {},
    cajaRegistroOrigenNombre: null,
    cajaRegistroDestinoId: 0,
    cajaRegistroDestino: {},
    cajaRegistroDestinoNombre: null,
    observaciones: '',

    /* Documentos */
    pesos: 0,

    cajaTransferenciaDatos: [],
    cajaTransferenciaDocumentos: []
};

const mutations = {
    updateField,

    'INICIALIZAR_CAJA_TRANSFERENCIA' (state) {
        state.id = 0;
        state.cajaRegistroOrigenId= 0;
        state.cajaRegistroOrigen= null;
        state.cajaRegistroOrigenNombre= null;
        state.cajaRegistroDestinoId= 0;
        state.cajaRegistroDestino= null;
        state.cajaRegistroDestinoNombre= null;
        state.observaciones = '';

        state.pesos = 0;
    },
    'SET_CAJA_ORIGEN'(state, cajaRegistro) {
        state.cajaRegistroOrigen = cajaRegistro;
        state.cajaRegistroOrigenId = cajaRegistro ? cajaRegistro.id : 0;
        state.cajaRegistroOrigenNombre = cajaRegistro ? cajaRegistro.nombre.trim() : null;
    },
    'SET_CAJA_DESTINO'(state, cajaRegistro) {
        state.cajaRegistroDestino = cajaRegistro;
        state.cajaRegistroDestinoId = cajaRegistro ? cajaRegistro.id : 0;
        state.cajaRegistroDestinoNombre = cajaRegistro ? cajaRegistro.nombre.trim() : null;
    },

    'INICIALIZAR_DATOS' (state) {
        state.cajaTransferenciaDatos = [];
        state.cajaTransferenciaDocumentos = [];
    },
    'SET_CAJA_TRANSFERENCIA_DATOS' (state, params) {
        state.cajaTransferenciaDatos = params.cajaTransferenciaDatos;
        state.cajaTransferenciaDocumentos = params.cajaTransferenciaDocumentos;
    },
};

const getters = {
    getField,

    totalDocumentos(state) {
        return parseFloat(state.pesos);
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJA_TRANSFERENCIA');
            resolve();
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            if (parseFloat(state.pesos) == 0) {
                save = false;
                errorMessage = 'Debe ingresar los documentos a transferir.';
            }

            if (save) {
                let cajaTransferencia= {
                    cajaRegistroOrigenId: parseInt(state.cajaRegistroOrigenId),
                    cajaRegistroDestinoId: parseInt(state.cajaRegistroDestinoId),
                    observaciones: state.observaciones.trim(),
                    pesos: parseFloat(state.pesos)
                };
                
                let url = 'cajastransferencias';

                apiAxios.post(url, cajaTransferencia)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

    setCajaRegistroOrigen: ({ commit }, cajaRegistro) => {
        return new Promise((resolve, reject) => {
            commit('SET_CAJA_ORIGEN', cajaRegistro);    
            resolve();
        }, error => {
            reject(error);
        })
    },
    setCajaRegistroDestino: ({ commit }, cajaRegistro) => {
        return new Promise((resolve, reject) => {
            commit('SET_CAJA_DESTINO', cajaRegistro);    
            resolve();
        }, error => {
            reject(error);
        })
    },
    getDatos ( { commit }, cajaTransferenciaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (cajaTransferenciaId) {
                apiAxios.get('cajastransferencias/' + cajaTransferenciaId) 
                    .then(res => {
                        let cajaTransferenciaDatos = [
                            { 'nombre': 'id', 'campo': 'Nro. Transferencia', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'cajaOrigen', 'campo': 'Origen', 'valor': res.data.cajaOrigen, 'formato': '' },
                            { 'nombre': 'cajaDestino', 'campo': 'Destino', 'valor': res.data.cajaDestino, 'formato': '' },
                            { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },
                        ]

                        let params = {
                            cajaTransferenciaDatos,
                            cajaTransferenciaDocumentos: res.data.documentos
                        }
                                      
                        commit('SET_CAJA_TRANSFERENCIA_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}